import $ from 'jquery'

import form from '../../edit/form/form'

import documentInsert from '../../lib/documentInsert'
import documentUpdate from '../../lib/documentUpdate'
import documentRemove from '../../lib/documentRemove'

import * as timecode from '../../../../lib/timecode'

export function getName(){
  return 'userMarker'
}

export function getTableColumns(o,item){

  var columns = [
    {
      id: 'roll',
      value: item.roll,
      type: o.type.text,
    },
    {
      id: 'start',
      value: item.start,
      type: o.type.timecode,
    },
    {
      id: 'notes',
      value: item.notes,
      type: o.type.textLong,
      width: 300,
      multiline: true,
    },
    {
      id: 'user',
      value: item.user,
      type: o.type.text,
      auth: ['admin','author'],
    },
    {
      id: 'date',
      value: item.date,
      type: o.type.date,
    },
  ]

  return columns

}

export function getTableData(o){

  var data =
    _.map(

      _.filter(o.data.userMarkers, function(m){
        return m.user == o.store('email') || o.store('role') == "admin"
      }),

      function(item){

        var model = o.model.userMarkers
        var columns = model.getTableColumns(o,item)

        var click =
          function(){
            var roll = _.find(o.data.rolls, {roll: item.roll})
            var start = timecode.toSeconds(item.start)
            o.player.load(roll,start)
            o.edit.set(item,model)
          }

        return {
          columns: columns,
          click: click,
        }

      }
    )

  return data

}

export function getFormFields(o,item){

  var lang = o.store('lang')

  if(!item){
    var item = {}
  }

  if(o.loopStart){
    var start = timecode.toSmtp(o.loopStart)
  } else {
    var start = timecode.toSmtp(0)
  }

  var init = {
    roll: o.roll,
    start: start,
  }

  var fields = [
    {
      id: 'roll',
      value: item.roll,
      type: 'text',
      init: init.roll,
    },
    {
      id: 'start',
      value: item.start,
      type: 'timecode',
      edit: true,
      init: init.start,
    },
    {
      id: 'notes',
      value: item.notes,
      type: 'textLong',
      optional: true,
      edit: true,
    },
  ]

  return fields

}

export function insertForm(o,done){

}

export function remove(o,id,done){

  var data = o.data.userMarkers
  var collection = 'userMarkers'

  documentRemove(o,data,id,collection,done)

}

export function insert(o,item,done){

  var lang = o.store('lang')

  var data = o.data.userMarkers
  var collection = 'userMarkers'

  var d = function(error,item){
    o.player.updateMarkers()
    done(error,item)
  }

  item.user = o.store('email')
  item.date = new Date()

  documentInsert(o,data,item,collection,d)

}

export function update(o,id,changes,done){

  var lang = o.store('lang')

  var data = o.data.userMarkers
  var collection = 'userMarkers'

  var startChange = _.find(changes,{id: 'start'})

  if(startChange){
    var marker = _.find(data,{_id: id})
    var roll = marker.roll
    var start = startChange.value
  }

  changes.push({
    id: 'date',
    value: new Date(),
  })

  documentUpdate(o,data,id,changes,collection,done)

}



// WEBPACK FOOTER //
// ./src/client/view/admin/model/userMarkers/userMarkers.js